module.exports = __webpack_public_path__ + "img/mailchimp.6e91d9da.jpg";